<div class="filters-panel" [style.top.px]="position().top" [style.left.px]="position().left">
  <div class="filters-panel__header">
    <span class="filters-panel__title">Filtros avançados</span>
  </div>
  <div class="filters-panel__body">
    @for (field of boardFields(); track field.id) {
      <div class="filters-panel__row">
        <span class="filters-panel__label">{{ field.label }}</span>
        @if (field.type !== 'date' || !isDateRangeDraft(field.id)) {
          <select
            class="filters-panel__operator"
            [ngModel]="getDraft(field.id, field).operator"
            (ngModelChange)="onOperatorChange(field.id, field, $event)"
          >
            @for (op of getOperators(field); track op) {
              <option [value]="op">{{ operatorSymbols[op] }}</option>
            }
          </select>
        }
        @switch (field.type) {
          @case ('date') {
            <visio-date-picker
              placeholder="Data..."
              [selectedDate]="getDateDraftDisplay(field.id)"
              [range]="true"
              (change)="onDateChange(field.id, $event)"
            ></visio-date-picker>
          }
          @case ('boolean') {
            <select
              class="filters-panel__input filters-panel__input--select"
              [ngModel]="getDraft(field.id, field).value"
              (ngModelChange)="onValueChange(field.id, field, $event)"
            >
              <option value="">Selecionar...</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          }
          @case ('number') {
            <input
              class="filters-panel__input"
              type="number"
              placeholder="Valor..."
              [ngModel]="getDraft(field.id, field).value"
              (ngModelChange)="onValueChange(field.id, field, $event)"
            />
          }
          @case ('user') {
            <visio-combobox
              placeholder="Usuário..."
              [items]="users()[field.id] ?? []"
              [ngModel]="getDraft(field.id, field).value"
              (ngModelChange)="onValueChange(field.id, field, $event)"
            ></visio-combobox>
          }
          @default {
            <input
              class="filters-panel__input"
              type="text"
              placeholder="Valor..."
              [ngModel]="getDraft(field.id, field).value"
              (ngModelChange)="onValueChange(field.id, field, $event)"
            />
          }
        }
      </div>
    }
  </div>
  <div class="filters-panel__footer">
    <visio-button [class]="'text-button'" (click)="clearAll()">Limpar tudo</visio-button>
    <visio-button (click)="applyFilters()">Aplicar filtros</visio-button>
  </div>
</div>
